/* istanbul ignore file */
/*
 * Default settings used by a Modal instance if not otherwise overwritten with config
 *
 * @property onClassName, String, 
 * @property toggleSelectorAttribute, String
 * @property callback, Function
 * @property startOpen, Boolean
 * @property delay, Number
 */
export default {
    onClassName: 'is--active',
    toggleSelectorAttribute: 'data-modal-toggle',
    callback: false,
    startOpen: false,
    delay: 0
};